import gql from 'graphql-tag';

export const ProductPriceOverrides = gql`
    fragment ProductPriceOverrides on Product {
        PriceOverrides {
            edges {
                node {
                    ID # Brand or Branch
                    ... on OfficesBranch {
                        BrandID
                        _join {
                            PriceOverride {
                                ID
                                BasePrice
                                SellingPrice
                                PriceTier
                            }
                        }
                    }
                    ... on OfficesUsername {
                        Branches {
                            nodes {
                                ID
                            }
                        }
                        _join {
                            PriceOverride {
                                ID
                                BasePrice
                                SellingPrice
                                PriceTier
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const VariationPriceOverrides = gql`
    fragment VariationPriceOverrides on Variation {
        PriceOverrides {
            edges {
                node {
                    ID # Brand or Branch
                    ... on OfficesBranch {
                        BrandID
                        _join {
                            PriceOverride {
                                ID
                                BasePrice
                                SellingPrice
                                PriceTier
                            }
                        }
                    }
                    ... on OfficesUsername {
                        Branches {
                            nodes {
                                ID
                            }
                        }
                        _join {
                            PriceOverride {
                                ID
                                BasePrice
                                SellingPrice
                                PriceTier
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default gql`
    fragment Product on Product {
        ID
        Created
        LastEdited
        ImageID
        ImageURL
        ImagePortraitURL
        ImageLandscapeURL
        Title
        Content
        BasePrice
        SellingPrice
        BaseWorth
        PurchasePrice
        XeroCostsCode
        XeroSalesCode
        Quantity
        GST
        ITC
        LegacyKey
        AllowPurchase
        CoffinTrim
        InternalItemID
        Parent {
            ID
            ... on ProductCategory {
                Title
                URLSegment
            }
            ... on CoreProductCategory {
                Title
                URLSegment
            }
        }
        ProductCategories {
            ID
            ... on ProductCategory {
                Title
                URLSegment
            }
            ... on CoreProductCategory {
                Title
                URLSegment
            }
        }
        RelatedProducts {
            edges {
                node {
                    ID
                }
            }
        }
        VariationAttributeTypes {
            nodes {
                ID
                Name
                Label
            }
        }
        Variations(limit: 999) {
            edges {
                node {
                    ID
                    Price
                    Worth
                    SellingPrice
                    PurchasePrice
                    GST
                    ITC
                    LegacyKey
                    InternalItemID
                    IsRetired
                    canArchive
                    AttributeValues {
                        edges {
                            node {
                                ID
                                Value
                                Type {
                                    ID
                                    Label
                                }
                            }
                        }
                    }
                    ...VariationPriceOverrides
                }
            }
        }
        ...ProductPriceOverrides
    }
    ${ProductPriceOverrides}
    ${VariationPriceOverrides}
`;
